import App from './App';
import { ToastProvider } from './components/ui/toast';
import { AuthProvider } from './contexts/AuthProvider';
import { LaunchDarklyProvider } from './providers/LaunchDarklyProvider';
import { PostHogProviderWrapper } from './providers/PostHogProviderWrapper';

export const AppProviders = () => (
  <AuthProvider>
    <ToastProvider>
      <LaunchDarklyProvider>
        <PostHogProviderWrapper>
          <App />
        </PostHogProviderWrapper>
      </LaunchDarklyProvider>
    </ToastProvider>
  </AuthProvider>
);
